import { IAGPortfolioDataRow } from "@pulse-ui/types/components/AGTable";
import { IAlertMessage } from "@pulse-ui/types/components/AlertMessage";
import { ISelectOption } from "@pulse-ui/types/components/DropdownInput";
import { IVenueApiKey } from "@pulse-ui/codegen/generated_ts/authn";

// Dialog title props
export interface DialogTitleProps {
    className: string;
    children?: React.ReactNode;
    onClose: () => void;
}

// Dropcopy IP address
export interface IDropcopyIp {
    label: string;
    ip: string;
}

// Account form data
export interface IAccountForm {
    [key: string]: string | boolean | null;
    display_name: string;
    account_id: string;
    is_active: boolean;
    created: string;
    last_modified: string;
    strategy: string;
    strategy_id: string | null;
}

// API key form errors
export interface IApiKeyFormErrors {
    account_id: boolean;
    portfolio_id: boolean;
    access_key: boolean;
    secret_key: boolean;
    venue: boolean;
    allow_ip: boolean;
    api_capabilities: boolean;
}

// Transform all fields to a specific type
export type TransformFields<T, FieldType> = {
    [K in keyof T]: FieldType;
};

// Venue API key payload (all fields as strings or arrays)
export type VenueApiKeyPayload = TransformFields<
    IVenueApiKey,
    string | string[] | null
>;

// Input field configuration
export type InputFields = {
    name: string;
    label: string;
    group: typeof AUTOGENERATED | typeof USER_INPUT | typeof FIX;
    type: string;
    options?: ISelectOption[];
    editable?: boolean;
};

// Constants for input field groups
export const NEW_KEY = "NEW_KEY";
export const AUTOGENERATED = "autogenerated";
export const USER_INPUT = "user_input";
export const FIX = "fix";

export interface IAccountDetails {
    account_id: string;
    display_name: string;
    portfolio_id: string | null;
    created?: string;
    last_modified?: string;
    is_active?: boolean;
    strategy?: string;
}

export interface AccountModalProps {
    open: boolean;
    accountId: string;
    portfolioId: string | null;
    onClose: () => void;
    dataMap?: Map<string, IAGPortfolioDataRow>;
    setDataMap?: React.Dispatch<React.SetStateAction<Map<string, IAGPortfolioDataRow>>>;
    setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    pushAlert?: (alert: IAlertMessage) => void;
    fetchVenueAccountsForExpandedRows?: (
        portfolios_map: Map<string, IAGPortfolioDataRow>
    ) => Promise<Map<string, IAGPortfolioDataRow>>;
}
